import { type ComponentType } from '@angular/cdk/portal';
import { type IFeature } from '@principle-theorem/feature-flags';

/**
 * Represents an AI feature dashboard configuration.
 * This contract defines how the AI Suite shell registers and loads
 * individual AI feature dashboards dynamically.
 */
export interface IAiSuiteFeature {
  /** Unique identifier for the AI feature. */
  id: string;
  /** Display label shown in the navigation sidebar. */
  label: string;
  /** Short description of the feature purpose. */
  description: string;
  /** Material icon name used in the navigation sidebar. */
  icon: string;
  /** Feature flag configuration to control visibility. */
  feature: IFeature;
  /** Lazy loads the standalone component for the dashboard. */
  loadComponent: () => Promise<ComponentType<unknown>>;
}
